// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"f84e0465","853":"6f1dd87d"}[chunkId] + ".chunk.js";
};